import { useEffect, useRef, useState } from "react";
import { ChevronDown } from "lucide-react";
import { SeoProse } from "./SeoProse";

const COLLAPSED_PX = 112; // matches max-h-28

// Collapsed "More about this product" — shows a short teaser, expands on demand.
// The full copy stays in the DOM (SEO), only visually clamped. Short copy that
// already fits gets no toggle.
export function MoreAboutProduct({ text, testid = "seo-body", cardClass = "card-base" }) {
  const [open, setOpen] = useState(false);
  const [overflows, setOverflows] = useState(true);
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const check = () => setOverflows(el.scrollHeight > COLLAPSED_PX + 8);
    check();
    const ro = new ResizeObserver(check);
    ro.observe(el);
    return () => ro.disconnect();
  }, [text]);
  if (!(text || "").trim()) return null;
  const clamped = overflows && !open;
  return (
    <div className={`${cardClass} p-6`} data-testid={testid}>
      <div className="flex items-center justify-between gap-4">
        <span className="overline">More about this product</span>
        {overflows && (
          <button
            type="button"
            onClick={() => setOpen((o) => !o)}
            aria-expanded={open}
            className="flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-wider text-slate-500 hover:text-[#DD6B33] transition-colors"
            data-testid={`${testid}-toggle`}
          >
            {open ? "Show less" : "Read more"}
            <ChevronDown className={`w-4 h-4 transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
          </button>
        )}
      </div>
      <div
        className={`relative mt-3 overflow-hidden transition-[max-height] duration-500 ease-in-out ${clamped ? "max-h-28" : "max-h-[8000px]"}`}
        data-testid={`${testid}-content`}
      >
        <div ref={ref}><SeoProse text={text} /></div>
        {clamped && <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-white to-transparent pointer-events-none" />}
      </div>
      {clamped && (
        <button type="button" onClick={() => setOpen(true)} className="mt-2 text-sm font-semibold text-[#DD6B33] hover:underline" data-testid={`${testid}-readmore`}>
          Read the full description →
        </button>
      )}
    </div>
  );
}
